module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wrap1 flex-col"
  }, [_c('div', {
    staticClass: "main7"
  }, [_c('div', {
    staticClass: "word5",
    style: (_vm.getFontStyle(_vm.contractProgressInfo))
  }, [_vm._v("\n          实验编号：" + _vm._s(_vm.contractProgressInfo.contractNo) + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-right": "15px",
      "display": "flex"
    },
    on: {
      "click": function($event) {
        return _vm.handleToExtension()
      }
    }
  }, [_c('span', {
    staticClass: "txt2 txt",
    class: _vm.getStatusClass(_vm.contractProgressInfo.status)
  }, [_vm._v("\n            " + _vm._s(_vm.contractProgressInfo.status) + "\n          ")]), _vm._v(" "), (_vm.contractProgressInfo.show) ? _c('svg', {
    staticClass: "label3",
    attrs: {
      "width": "16px",
      "height": "16px",
      "viewBox": "0 0 16 16",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("编组 4#merge#")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "进展查询",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "进展详情",
      "transform": "translate(-334.000000, -261.000000)",
      "fill": "#5878FA",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "展-开",
      "transform": "translate(342.000000, 269.000000) scale(1, -1) translate(-342.000000, -269.000000) translate(334.000000, 261.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00000975,15.911638 C3.62514752,15.911638 0.0800005364,12.366491 0.0800005364,8.00000975 C0.0800005364,3.63352848 3.62514752,0.0883814985 8.00000975,0.0883814985 C12.374872,0.0883814985 15.911638,3.63352848 15.911638,8.00839071 C15.911638,12.374872 12.366491,15.911638 8.00000975,15.911638 Z M8.00000975,14.9813512 C11.8552523,14.9813512 14.9813512,11.8552523 14.9813512,8.00000975 C14.9813512,4.14476717 11.8552523,1.0186683 8.00000975,1.0186683 C4.14476717,1.0186683 1.0186683,4.14476717 1.0186683,8.00000975 C1.0186683,11.8552523 4.14476717,14.9813512 8.00000975,14.9813512 Z M8.09220034,9.48344005 C9.46667813,8.11734322 9.91086912,7.68991415 11.2853469,6.32381733 C11.4278233,6.18134097 11.5870615,6.10591231 11.7882046,6.15619808 C12.1653479,6.2400077 12.3162053,6.67581774 12.0731573,6.96915141 C12.0480145,7.00267526 12.0144906,7.02781814 11.9893477,7.06134199 C10.4891555,8.55315325 9.91925008,9.10629675 8.41905786,10.598108 C8.14248611,10.8662988 7.86591436,10.8662988 7.59772357,10.598108 C6.08915039,9.09791579 5.510864,8.53639133 4.00229081,7.04458007 C3.8514335,6.89372275 3.7843858,6.72610351 3.83467157,6.52496042 C3.91010023,6.25676963 4.18667198,6.09753135 4.45486277,6.16457905 C4.52191047,6.18134097 4.58895816,6.21486482 4.63924394,6.25676963 C4.67276779,6.28191252 4.70629163,6.31543636 4.73981548,6.34896021 C6.10591231,7.70667608 6.54172234,8.13410515 7.90781917,9.48344005 C7.93296206,9.50858294 7.95810494,9.55048775 8.00000975,9.60915448 C8.04191456,9.55048775 8.06705745,9.50858294 8.09220034,9.48344005 Z",
      "id": "形状"
    }
  })])])])]) : _c('svg', {
    staticClass: "label3",
    attrs: {
      "width": "16px",
      "height": "16px",
      "viewBox": "0 0 16 16",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("编组 4#merge# 2")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "进展查询",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "进展详情",
      "transform": "translate(-334.000000, -261.000000)",
      "fill": "#5878FA",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "展-开",
      "transform": "translate(334.000000, 261.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00000975,15.911638 C3.62514752,15.911638 0.0800005364,12.366491 0.0800005364,8.00000975 C0.0800005364,3.63352848 3.62514752,0.0883814985 8.00000975,0.0883814985 C12.374872,0.0883814985 15.911638,3.63352848 15.911638,8.00839071 C15.911638,12.374872 12.366491,15.911638 8.00000975,15.911638 Z M8.00000975,14.9813512 C11.8552523,14.9813512 14.9813512,11.8552523 14.9813512,8.00000975 C14.9813512,4.14476717 11.8552523,1.0186683 8.00000975,1.0186683 C4.14476717,1.0186683 1.0186683,4.14476717 1.0186683,8.00000975 C1.0186683,11.8552523 4.14476717,14.9813512 8.00000975,14.9813512 Z M8.09220034,9.48344005 C9.46667813,8.11734322 9.91086912,7.68991415 11.2853469,6.32381733 C11.4278233,6.18134097 11.5870615,6.10591231 11.7882046,6.15619808 C12.1653479,6.2400077 12.3162053,6.67581774 12.0731573,6.96915141 C12.0480145,7.00267526 12.0144906,7.02781814 11.9893477,7.06134199 C10.4891555,8.55315325 9.91925008,9.10629675 8.41905786,10.598108 C8.14248611,10.8662988 7.86591436,10.8662988 7.59772357,10.598108 C6.08915039,9.09791579 5.510864,8.53639133 4.00229081,7.04458007 C3.8514335,6.89372275 3.7843858,6.72610351 3.83467157,6.52496042 C3.91010023,6.25676963 4.18667198,6.09753135 4.45486277,6.16457905 C4.52191047,6.18134097 4.58895816,6.21486482 4.63924394,6.25676963 C4.67276779,6.28191252 4.70629163,6.31543636 4.73981548,6.34896021 C6.10591231,7.70667608 6.54172234,8.13410515 7.90781917,9.48344005 C7.93296206,9.50858294 7.95810494,9.55048775 8.00000975,9.60915448 C8.04191456,9.55048775 8.06705745,9.50858294 8.09220034,9.48344005 Z",
      "id": "形状"
    }
  })])])])])])]), _vm._v(" "), (_vm.contractProgressInfo.progressNotes.length > 0) ? _c('div', {
    staticClass: "main8 flex-col",
    class: {
      mianb:
        _vm.contractProgressInfo.progressNotes.length > 0 &&
        _vm.contractProgressInfo.show,
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contractProgressInfo.show) ? _c('div', [(_vm.contractProgressInfo.progressNotes.length > 0) ? [_c('div', {
    staticClass: "main9 flex-row justify-between"
  }, [_c('div', {
    staticClass: "outer2 flex-col"
  }), _vm._v(" "), _c('div', {
    staticClass: "outer3 flex-col"
  }, [_c('span', {
    staticClass: "txt3",
    on: {
      "click": function($event) {
        return _vm.handleToHistoryProgress(_vm.contractProgressInfo)
      }
    }
  }, [_vm._v("历史进展")])])]), _vm._v(" "), _c('span', {
    staticClass: "paragraph1"
  }, [_c('span', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("\n              1.  " + _vm._s(_vm.contractProgressInfo.progressNotes[0].content) + "\n            ")])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main10 flex-col"
  }), _vm._v(" "), _vm._l((_vm.contractProgressInfo.experimentModules), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "main11",
      on: {
        "click": function($event) {
          return _vm.handleToExperimentDetail(item.taskModules)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [(item.completedPercent !== '100') ? _c('div', {
      staticClass: "pie-simple layer4",
      class: {
        allcomplete: item.completedPercent === '100'
      },
      style: ({
        '--percent': item.completedPercent
      })
    }, [_c('div', {
      staticClass: "pie-left flex-col"
    }), _vm._v(" "), _c('div', {
      staticClass: "pie-right flex-col"
    })]) : _c('div', [_c('svg', {
      staticClass: "left1",
      staticStyle: {
        "display": "block",
        "margin": "auto",
        "margin-top": "3px"
      },
      attrs: {
        "width": "14px",
        "height": "14px",
        "viewBox": "0 0 14 14",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('title', [_vm._v("对勾#merge#")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
      attrs: {
        "id": "课题组",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "进展查询-病毒",
        "transform": "translate(-28.000000, -198.000000)",
        "fill": "#5878FA",
        "fill-rule": "nonzero"
      }
    }, [_c('g', {
      attrs: {
        "id": "对勾#merge#",
        "transform": "translate(28.000000, 198.000000)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M7,0 C3.12083789,0 0,3.12083789 0,7 C0,10.8791621 3.12083789,14 7,14 C10.8791621,14 14,10.8791621 14,7 C14,3.12083789 10.8791621,0 7,0 Z M11.375,5.25 L6.7375,9.8875 L6.73749997,9.88750003 C6.39225641,10.2085075 5.85774352,10.2085075 5.51249997,9.88749997 L2.62499997,6.99999997 C2.62499997,6.99999997 2.18749997,6.56249997 2.62499997,6.12499997 C3.06249997,5.68749997 3.49999997,6.12499997 3.49999997,6.12499997 L6.12499997,8.74999997 L10.5,4.37499997 C10.5,4.37499997 10.9375,3.93749997 11.375,4.37499997 C11.8125,4.81249997 11.375,5.24999997 11.375,5.24999997 L11.375,5.25 Z",
        "id": "形状"
      }
    })])])])])]), _vm._v(" "), _c('span', {
      staticClass: "info5",
      style: ({
        color: item.isException ? 'red' : ''
      })
    }, [_vm._v(_vm._s(item.experimentName))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex"
      },
      style: (item.isException ? {
        'margin-top': '4px'
      } : '')
    }, [(item.isException) ? _c('span', {
      staticClass: "txt2 layer7",
      staticStyle: {
        "margin-right": "15px"
      }
    }, [_vm._v("\n               " + _vm._s(_vm.getExceptionName()) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "label4",
      attrs: {
        "referrerpolicy": "no-referrer",
        "src": "/static/img/SketchPngf5a755bb1e7cc63077d460c4e20c96f4462ddbe798b160a88a0eb60fb5e54057.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "main8 flex-col",
      class: {
        mianb: index < _vm.contractProgressInfo.experimentModules.length - 1,
      }
    })])
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.contractProgressInfo.progressNotes.length > 0) ? _c('span', {
    staticClass: "txt4"
  }, [_vm._v(_vm._s(_vm.contractProgressInfo.progressNotes[0].createDT) + " 最新进展："), _c('svg', {
    attrs: {
      "width": "25px",
      "height": "11px",
      "viewBox": "0 0 25 11",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("最新")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "进展查询",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "进展详情",
      "transform": "translate(-192.000000, -308.000000)",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "最新",
      "transform": "translate(192.000000, 308.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4.71428418,0 L24.357126,0 L24.357126,6.28571582 L24.357126,6.28571582 C24.357126,8.88934277 22.2464688,11 19.6428418,11 L3.93262024e-15,11 L3.93262024e-15,4.71428418 L3.93262024e-15,4.71428489 C3.93262024e-15,2.11065794 2.11065723,0 4.71428418,0 L4.71428418,0 Z",
      "id": "路径",
      "fill": "#FE654D"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.35777988,7.85716895 L5.35777988,2.62429492 L6.42556943,2.62429492 L7.94592197,5.41044238 L8.46920723,6.54187402 L8.50456438,6.54187402 C8.44799291,5.99737402 8.37020755,5.30437402 8.37020755,4.71037402 L8.37020755,2.62429492 L9.36020755,2.62429492 L9.36020755,7.85716895 L8.2994928,7.85716895 L6.78620862,5.05687402 L6.25585179,3.93252148 L6.22049463,3.93252148 C6.26999463,4.49823623 6.34777988,5.15587402 6.34777988,5.75695312 L6.34777988,7.85716895 L5.35777988,7.85716895 L5.35777988,7.85716895 Z M10.6542842,7.85715713 L10.6542842,2.62429492 L13.8647158,2.62429492 L13.8647158,3.49408018 L11.7008633,3.49408018 L11.7008633,4.703296 L13.5394316,4.703296 L13.5394316,5.58015283 L11.7008633,5.58015283 L11.7008633,6.98030029 L13.9425107,6.98030029 L13.9425107,7.85715713 L10.6542842,7.85715713 L10.6542842,7.85715713 Z M15.4982158,7.85714746 L14.4870011,2.62429492 L15.5547863,2.62429492 L15.9720011,5.1770791 C16.0497868,5.72865068 16.1346442,6.28729492 16.2124295,6.84593164 L16.2407152,6.84593164 C16.3467867,6.28728848 16.4599299,5.7215791 16.573072,5.1770791 L17.1812152,2.62429492 L18.0722152,2.62429492 L18.6803583,5.1770791 C18.7935015,5.71450752 18.8995731,6.28022656 19.0127152,6.84593164 L19.0480723,6.84593164 C19.125858,6.28021689 19.2036439,5.7215791 19.2814292,5.1770791 L19.6915723,2.62429492 L20.6886439,2.62429492 L19.7198587,7.85714746 L18.4187112,7.85714746 L17.8317828,5.269 L17.8317825,5.26899871 C17.7473926,4.86765555 17.6719452,4.46448514 17.6054973,4.05978289 L17.5772116,4.05978289 C17.5064973,4.45578289 17.4357832,4.85885447 17.3509263,5.26899871 L16.7781411,7.85714746 L15.4982094,7.85714746 L15.4982158,7.85714746 Z",
      "id": "形状",
      "fill": "#FFFFFF"
    }
  })])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e65c008","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/serviceProgressRefactor/serviceProgress/ContractProgressInfo.vue
// module id = 1682
// module chunks = 8